module.exports = __webpack_public_path__ + "img/Priscillak.fed4cd74.svg";